import {STORE_MONITOR_INITIALIZE} from "../../../constants/MonitorConstants";
import {GeneralAction, UserMonitorPayload} from "../../../@types/actions";

export const StoreSettingAction = (data: UserMonitorPayload): GeneralAction<UserMonitorPayload> => ({
    type: STORE_MONITOR_INITIALIZE,
    payload: data
});
